export const otConstants = {
    GETALL_REQUEST_OT: 'GETALL_REQUEST_OT',
    GETALL_SUCCESS_OT: 'GETALL_SUCCESS_OT',
    GETALL_FAILUR_OT: 'GETALL_FAILURE_OT',
    GETALL_SUCCESS_EMPRESAS: 'GETALL_SUCCESS_EMPRESAS'
};
